import * as React from "react";

function SvgArrowTop(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 5.414V14H7V5.414L3.707 8.707 2.293 7.293 8 1.586l5.707 5.707-1.414 1.414L9 5.414z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgArrowTop;
